import loadable from '@loadable/component';

const iconsChunk = () =>
  import(/* webpackChunkName: "core-react-icons" */ './icons.chunk');

export const AbsoluteNumberIcon = loadable(() =>
  iconsChunk().then(m => m.AbsoluteNumberIcon),
);

export const AverageIcon = loadable(() =>
  iconsChunk().then(m => m.AverageIcon),
);
export const BalanceIcon = loadable(() =>
  iconsChunk().then(m => m.BalanceIcon),
);
export const ConfidenceIcon = loadable(() =>
  iconsChunk().then(m => m.ConfidenceIcon),
);
export const ConfidenceLogoOutlined = loadable(() =>
  iconsChunk().then(m => m.ConfidenceLogoOutlined),
);

export const DoubleIcon = loadable(() => iconsChunk().then(m => m.DoubleIcon));
export const ExperimentIcon = loadable(() =>
  iconsChunk().then(m => m.ExperimentIcon),
);

export const FigmaIcon = loadable(() => iconsChunk().then(m => m.FigmaIcon));
export const GitlabIcon = loadable(() => iconsChunk().then(m => m.GitlabIcon));
export const GoogleDocIcon = loadable(() =>
  iconsChunk().then(m => m.GoogleDocIcon),
);

export const IntIcon = loadable(() => iconsChunk().then(m => m.IntIcon));
export const JiraIcon = loadable(() => iconsChunk().then(m => m.JiraIcon));
export const JsonIcon = loadable(() => iconsChunk().then(m => m.JsonIcon));
export const LinearIcon = loadable(() => iconsChunk().then(m => m.LinearIcon));
export const MeasurementSQLIcon = loadable(() =>
  iconsChunk().then(m => m.MeasurementSQLIcon),
);
export const MetricWindowIcon = loadable(() =>
  iconsChunk().then(m => m.MetricWindowIcon),
);
export const MiroIcon = loadable(() => iconsChunk().then(m => m.MiroIcon));
export const NotionIcon = loadable(() => iconsChunk().then(m => m.NotionIcon));
export const RelativeNumberIcon = loadable(() =>
  iconsChunk().then(m => m.RelativeNumberIcon),
);

export const TopRightSwirlArrowIcon = loadable(() =>
  iconsChunk().then(m => m.TopRightSwirlArrowIcon),
);
export const LeftSwirlArrowIcon = loadable(() =>
  iconsChunk().then(m => m.LeftSwirlArrowIcon),
);

// this needed from the start, so it's ok to go into main chunk
export { RolloutIcon } from './RolloutIcon';
export { ConfidenceLogo } from './ConfidenceLogo';
export * from './encore-web';
export { ConfidenceLogoInverted } from './ConfidenceLogoInverted';

export { GridViewIcon } from './GridViewIcon';
